import React, {useEffect,useState} from 'react';

const Experience = () => {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const experiences = [
    {
      company: "Georgia Institute of Technology",
      iconUrl: "/gt.png",
      role: "Master's Student",
      period: "AUG 2025 - MAY 2028",
      description: "Major: Computer Science - Machine Learning Specialization",
      side: "right"
    },
    {
      company: "Northrop Grumman",
      iconUrl: "/ng.png",
      role: "SOFTWARE ENGINEER II",
      period: "MAY 2024 - PRESENT",
      description: "Designed and created 40+ new features for an idea incubator app, business value tracker, and risk and opportunity app. Created and executed 25+ automated end-to-end integration tests for a material estimating app. Built automations that improved an app's deployment process using Git Webhooks and Kubernetes.",
      side: "left"
    },
    {
      company: "Northrop Grumman",
      iconUrl: "/ng.png",
      role: "SOFTWARE ENGINEER I",
      period: "AUG 2022 - MAY 2024",
      description: "Streamlined site stand-ups and migrations with Python scripts, saving over 2,000 minutes. Improved data visibility for users by developing scripts to display key deployment metrics. Automated tedious server admin tasks by leveraging Powershell and Ansible, saving over 50 hours.",
      side: "right"
    },
    {
      company: "JETSWEAT",
      iconUrl: "/jetsweat.png",
      role: "Software Developer Intern",
      period: "JULY 2021 - SEP 2021",
      description: "Developed, tested, and optimized server-side logic by streamlining queries, eliminating redundant code, and expanding the API to support new features. Designed and created React code for new frontend features on the fitness platform, including rendering modals and displaying fitness class analytics.",
      side: "left"
    },
    {
      company: "JAM Ventures Marketing",
      iconUrl: "/jvm.png",
      role: "Co-Owner",
      period: "JULY 2018 - OCT 2020",
      description: "Automated tasks within our sales process by leveraging Python and Selenium to extract thousands of emails from the internet, which saved over 80 hours and brought in over $5,000. Communicated closely with 100’s of business owners and their teams to strategically plan and execute a digital marketing strategy geared towards their needs and specifications. Took on a customer-focused role where I exercised my business acumen and communication skills, thus understanding prospects’ needs, setting expectations, and taking action.",
      side: "right"
    },
    {
      company: "UC Davis",
      iconUrl: "/ucd.png",
      role: " Undergraduate Student",
      period: "SEP 2018 - JUNE 2022",
      description: "Major: Computer Engineering",
      side: "left"
    }
  ];

 const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#1a1a1a',
      color: '#ffffff',
      padding: '2rem',
      fontFamily: 'Arial, sans-serif'
    },
    title: {
      fontSize: isMobile ? '2rem' : '3rem',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '4rem',
      letterSpacing: '0.1em'
    },
    timelineWrapper: {
      maxWidth: '1200px',
      margin: '0 auto',
      position: 'relative'
    },
    verticalLine: {
      position: 'absolute',
      left: isMobile ? '32px' : '50%',
      transform: isMobile ? 'none' : 'translateX(-50%)',
      width: '2px',
      backgroundColor: '#4a4a4a',
      height: '100%',
      top: 0
    },
    timelineItem: {
      position: 'relative',
      marginBottom: '4rem',
      display: 'flex',
      alignItems: isMobile ? 'flex-start' : 'center',
      paddingLeft: isMobile ? '100px' : '0'
    },
    iconContainer: {
      position: 'absolute',
      left: isMobile ? '0' : '50%',
      transform: isMobile ? 'none' : 'translateX(-50%)',
      width: '64px',
      height: '64px',
      backgroundColor: '#1a1a1a',
      borderRadius: '50%',
      border: '4px solid #ffffff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10,
      overflow: 'hidden'
    },
    iconImage: {
      width: '40px',
      height: '40px',
      objectFit: 'contain'
    },
    contentBox: {
      border: '2px solid #ffffff',
      borderRadius: '8px',
      padding: '1.5rem',
      backgroundColor: '#1a1a1a',
      width: isMobile ? '100%' : 'auto'
    },
    contentLeft: {
      width: '42%',
      marginRight: 'auto'
    },
    contentRight: {
      width: '42%',
      marginLeft: 'auto'
    },
    roleTitle: {
      fontSize: '1.25rem',
      fontWeight: 'bold',
      marginBottom: '0.5rem',
      textTransform: 'uppercase'
    },
    period: {
      fontSize: '0.875rem',
      fontWeight: '600',
      marginBottom: '1rem',
      textTransform: 'uppercase'
    },
    description: {
      fontSize: '0.875rem',
      lineHeight: '1.6'
    }
  };


  return (
    <div style={styles.container} id="timeline">
      <h1 style={styles.title}>EXPERIENCE</h1>
      
      <div style={styles.timelineWrapper}>
        <div style={styles.verticalLine}></div>
        
        {experiences.map((exp, index) => (
          <div key={index} style={styles.timelineItem}>
            <div style={styles.iconContainer}>
              <img src={exp.iconUrl} alt={`${exp.company} logo`} style={styles.iconImage} />
            </div>
            
            <div style={{
              ...styles.contentBox, 
              ...(isMobile ? {} : (exp.side === 'left' ? styles.contentLeft : styles.contentRight))
            }}>
              <h2 style={styles.roleTitle}>
                {exp.company} | {exp.role}
              </h2>
              <p style={styles.period}>{exp.period}</p>
              <p style={styles.description}>{exp.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experience;